import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetHealthCheck: IMcAppType = {
  name: "internetHealthCheck",
  path: "/my/internet/health-check",
  description: "Internet Health Check",
  parameters: {
    properties: {
      accountNumber: CommonParameters.superloopAccountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Internet health check",
  parent: Tab.DASHBOARD, // Changed from Tab.USAGE, Temporary workaround due to navigation issues on Mobile with FOCUS flow
  conditions: {
    intent: "internetHealthCheck",
    customerType: CustomerType.kraken,
  },
};
